interface BranchAlias {
  id: string;
  name: string;
  original_name: string;
}

let BranchAliases: BranchAlias[] | undefined = undefined;
export const GetBranchAliases = () => {
  if (BranchAliases) return BranchAliases;
  if (!window.__BRANCH_ALIASES__) return undefined;
  try {
    const decoded = JSON.parse(atob(window.__BRANCH_ALIASES__)) as BranchAlias[];
    BranchAliases = decoded;
    return BranchAliases;
  } catch (e) {
    return undefined;
  }
};
